import { FormSelect } from '../../../common/form';
import { FC, useMemo } from 'react';
import { FormSelectSelectionPlaceholder } from '../../../common/form/input/FormSelectSelectionPlaceholder';
import { createAlgorithmSourceDimensionsOptionGroup } from '../sources/utils';
import { AlgorithmMappingsFormStore } from './AlgorithmMappingsFormStore';
import { i18nNsFactory } from '@atlas-frontend/i18n';
import translations from './AlgorithmMappingsFormModal.translations.json';

const { addTranslations } = i18nNsFactory(
  'algorithm-mappings-source-dimension-select',
);
addTranslations(translations);

interface AlgorithmMappingSourceDimensionSelectProps {
  name: string;
}

export const AlgorithmMappingSourceDimensionSelect: FC<
  AlgorithmMappingSourceDimensionSelectProps
> = (props) => {
  const { name } = props;

  const [algorithmSourcesBySourceType] = AlgorithmMappingsFormStore.useValue(
    'algorithmSourcesBySourceType',
  );

  const options = useMemo(
    () =>
      algorithmSourcesBySourceType
        .get('DOD')!
        .map((s, i) => createAlgorithmSourceDimensionsOptionGroup(s, i)),
    [algorithmSourcesBySourceType],
  );

  return (
    <FormSelect
      name={name}
      options={options}
      allowClear
      optionLabelProp="displayLabel"
      placeholder={<FormSelectSelectionPlaceholder />}
    />
  );
};
